import type { Member } from "@/types/Member";

/**
 * Returns true when the given member is the owner of an organisation.
 *
 * Two signals are accepted (either is sufficient):
 *  1. `member.ownerOfOrganisationId` is set — the server populates this field on the owner's
 *     own member record so it is the most reliable indicator.
 *  2. `member.organisation.ownerId === member.id` — the embedded organisation object is present
 *     and its ownerId matches the member (populated on some API responses).
 *
 * Mirrors the server-side `isOrganisationOwner` check in bookingCanBookValidation.ts.
 */
export function isOrganisationOwner(member: Member | null | undefined): boolean {
  if (!member) return false;

  if (member.ownerOfOrganisationId) return true;

  if (member.organisation?.ownerId && member.organisation.ownerId === member.id) return true;

  return false;
}
